module.exports = __webpack_public_path__ + "img/5.b8534b20.jpg";